import React from "react";
import { FiEye } from "react-icons/fi";
import ApprovalStatusBadge from "./ApprovalStatusBadge";

const ApprovalTableDesktop = ({ quotations, navigate }) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm transition-colors duration-300">
      <table className="w-full text-sm hidden md:table">
        <thead className="bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300 text-xs uppercase tracking-wide">
          <tr>
            <th className="px-3 py-2 font-semibold text-left">Run Number</th>
            <th className="px-3 py-2 font-semibold text-left">Title</th>
            <th className="px-3 py-2 font-semibold text-left">Client</th>
            <th className="px-3 py-2 font-semibold text-left">Document Date</th>
            <th className="px-3 py-2 font-semibold text-right">Net Amount</th>
            <th className="px-3 py-2 font-semibold text-center">Status</th>
            <th className="px-3 py-2 font-semibold text-left">Created By</th>
            <th className="px-3 py-2 font-semibold text-center">Actions</th>
          </tr>
        </thead>

        <tbody className="dark:text-gray-200">
          {quotations.length > 0 ? (
            quotations.map((qt, idx) => (
              <tr
                key={qt._id}
                className={`transition-colors duration-200 ${
                  idx % 2 === 0
                    ? "bg-white dark:bg-gray-900"
                    : "bg-gray-50/50 dark:bg-gray-800/70"
                } hover:bg-blue-50 dark:hover:bg-blue-900/30`}
              >
                {/* Run Number */}
                <td className="px-3 py-2 text-gray-800 dark:text-gray-200">
                  {qt.runNumber || "-"}
                </td>
                {/* Title */}
                <td className="px-3 py-2 max-w-[220px] truncate text-gray-800 dark:text-gray-200">
                  {qt.title || "-"}
                </td>
                {/* Client */}
                <td className="px-3 py-2 max-w-[220px] truncate text-gray-800 dark:text-gray-200">
                  {qt.client || "N/A"}
                </td>
                {/* Document Date */}
                <td className="px-3 py-2 text-gray-700 dark:text-gray-300">
                  {qt.documentDate
                    ? new Date(qt.documentDate).toLocaleDateString("en-GB")
                    : "-"}
                </td>
                {/* Net Amount */}
                <td className="px-3 py-2 text-right text-gray-800 dark:text-gray-200">
                  {qt.netAmount
                    ? qt.netAmount.toLocaleString("th-TH", {
                        style: "currency",
                        currency: "THB",
                      })
                    : "-"}
                </td>
                <td className="px-3 py-2 text-center">
                  <ApprovalStatusBadge status={qt.approvalStatus} />
                </td>
                <td className="px-3 py-2 text-gray-700 dark:text-gray-300">
                  {qt.createdByUser ? qt.createdByUser.split("@")[0] : "-"}
                </td>
                {/* Actions */}
                <td className="px-3 py-2 text-center">
                  <div className="flex justify-center">
                    <button
                      onClick={() => navigate(`/quotation-details/${qt._id}`)}
                      className="p-2 rounded-md bg-blue-100 text-blue-700 hover:bg-blue-200 
                         dark:bg-blue-900/40 dark:text-blue-300 dark:hover:bg-blue-800/60
                         transition-colors duration-200"
                      title="View"
                    >
                      <FiEye size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            // ✅ ไม่มีช่องว่างก่อน :
            <tr>
              <td
                colSpan="8"
                className="p-4 text-center text-gray-600 dark:text-gray-400"
              >
                No approval requests found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ApprovalTableDesktop;
